import './new-splash-screen.scss';

import HeaderContent from "@shared/ui/header-content/header-content";
import { Button } from "primereact/button";
import { FormProvider } from "react-hook-form";
import { FaChevronLeft } from "react-icons/fa6";

import FormSplashScreen from "../form-splash-screen/form-splash-screen";
import { useNewSplashScreen } from './new-splash-screen.hook';

export function NewSplashScreen() {  
  const {
    isCreating,
    formMethod,
    navigate,
    handleSubmit,
    handleValidate,
    handleValidateError,
  } = useNewSplashScreen();

  return (
    <div id="NewSplashScreen" className="splash-screen">
      <HeaderContent
        title={<h1>New Splash Screen</h1>}
        backIcon={<FaChevronLeft />}
        onBack={() => navigate("../")}
      >
        <Button
          className="w-full block"
          label="Save"
          disabled={isCreating}
          onClick={handleSubmit(handleValidate, handleValidateError)}
        ></Button>
      </HeaderContent>

      <div className="p-7">
        <FormProvider {...formMethod}>
          <section className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-4">
            <FormSplashScreen />
          </section>
        </FormProvider>
      </div>
    </div>
  );
}

export default NewSplashScreen;